import React from "react";
//#region types
import { VoucherFooterProps } from "models/propTypes/voucherPropsTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
import VoucherMoreActions from "./actions/moreActions";
//#endregion

const VoucherFooter: React.FC<VoucherFooterProps> = (props) => {
  return <PageFooter actions={[]} moreActions={<VoucherMoreActions voucher={props.voucher} />} />;
};

export default VoucherFooter;
